import type { SmetaKs3BridgeItem } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { formatDateRu, formatMoney } from '../ceoFormat';
import { Section, Table, TableWrap, Title } from './styles';

interface SmetaKs3ActsTableProps {
  acts: SmetaKs3BridgeItem[];
}

export function SmetaKs3ActsTable({ acts }: SmetaKs3ActsTableProps) {
  if (acts.length === 0) return null;

  return (
    <Section>
      <Title>
        Первичные справки КС-3, загруженные в модуле «ОСНОВА.Сметчик» ({acts.length})
      </Title>
      <TableWrap>
        <Table>
          <thead>
            <tr>
              <th>№ КС-3</th>
              <th>Файл</th>
              <th>Период по</th>
              <th>Сумма КС-3</th>
              <th>Зачёт аванса</th>
              <th>Гарантийное удержание</th>
              <th>К оплате (нетто)</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            {acts.map((act) => (
              <tr key={act.id}>
                <td>{act.act_no ?? '—'}</td>
                <td>{act.source_filename}</td>
                <td>{formatDateRu(act.period_to)}</td>
                <td>{formatMoney(act.total_period)}</td>
                <td>{formatMoney(act.advance_amount)}</td>
                <td>{formatMoney(act.retention_amount)}</td>
                <td>
                  <strong>{formatMoney(act.net_payable)}</strong>
                </td>
                <td>
                  <Badge $tone="info">{act.status}</Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableWrap>
    </Section>
  );
}
